import { Stack } from '@mui/material'
import { useState } from 'react'
import { toast } from 'react-toastify'
import spreadSheet from '../../../../../utils/spreadsheet'
import Modal from '../../../../molecules/Modal'
import ExportDataForm from './forms/ExportDataForm'
import PageHeader from './PageHeader'
import PageContent from './page_content'

const tableHeadData=["Date", "Items sold","Gross revenue(GH₵)", "Gross profit(GH₵)", "Shopkeeper",]

export default function Main() {

    const [modalOpen, setModalOpen] = useState(false)


    const handleOnHeaderButtonClick =()=>{
        setModalOpen(modalOpen ? false : true)
    }

    const handleOnExport = (data:any[])=>{

        if(data.length <= 0){
            toast("Error: No shops were created within the range you selected",{
                position: "top-center",
                type: "error",
                hideProgressBar: true,
                theme: "dark",
            })
            return
        }

        const cols:any[] = [];

        data.forEach((sale)=>{
            const arr = [
                    new Date(sale.created_at).toDateString(), 
                    sale.items_sold.reduce((prev:any, cur:any)=>prev + (cur["total_sold"] || 0), 0), 
                    sale.total_revenue.reduce((prev:any, cur:any)=>prev + (cur["revenue"] || 0), 0), 
                    sale.total_profit.reduce((prev:any, cur:any)=>prev + (cur["profit"] || 0), 0) ,
                    sale.shopkeeper, 
            ]
            cols.push(arr)
        })


        const aoa = [
            tableHeadData,
            ...cols
        ]

        spreadSheet.aoaToSpreadSheet(aoa, "Sales History")
        setModalOpen(false)
        
        
    }

    return (
        <Stack
            direction="column"
            spacing={2}
        >

            <PageHeader handleOnHeaderButtonClick={handleOnHeaderButtonClick} />

            <PageContent />
            
            <Modal
                title="Export sales history"
                subtitle="Select time range to export data"
                visible={modalOpen}
                setVisibility={setModalOpen}
            >
                <ExportDataForm 
                    onDone={handleOnExport}
                    onFail={()=>{}}
                />
            </Modal>


        </Stack>
    )

}



